import FadeIn from "./FadeIn";
import { C } from "./brandTokens";

interface ProblemSectionProps {
  onCTA: () => void;
}

export default function ProblemSection({ onCTA }: ProblemSectionProps) {
  return (
    <section className="py-[120px] px-6 sm:px-10" style={{ background: C.warm }}>
      <div className="max-w-[600px] mx-auto text-center">

        {/* The lived experience — Cormorant italic, speaks directly */}
        <FadeIn>
          <p
            className="font-heading italic text-spec-txt2"
            style={{ fontSize: "clamp(19px, 2.5vw, 24px)", lineHeight: 1.85 }}
          >
            "You open a blank page and close it again. Your prayer life feels more
            like maintenance than meaning. You read scripture, but it doesn't connect
            to what's actually happening in your life. You've tried journaling apps —
            they feel secular. Hollow."
          </p>
        </FadeIn>

        {/* Decorative rule */}
        <FadeIn delay={0.1}>
          <div
            className="mx-auto my-12"
            style={{ width: 1, height: 60, background: C.bdr }}
          />
        </FadeIn>

        {/* The framing */}
        <FadeIn delay={0.15}>
          <p className="font-ui text-[16px] text-spec-txt2 leading-[1.8] mb-5">
            Most Christians want a consistent, meaningful devotional life. But the
            tools available — generic journals, separate Bible apps, disconnected
            prayer lists — put the burden of integration entirely on you.
          </p>
          <p className="font-ui text-[16px] text-spec-txt2 leading-[1.8] font-medium">
            The result isn't a spiritual practice. It's spiritual maintenance. And
            maintenance doesn't produce growth.
          </p>
        </FadeIn>

        {/* Inline text invitation — not a button, a suggestion */}
        <FadeIn delay={0.25}>
          <div
            className="mt-12 pt-12"
            style={{ borderTop: `1px solid ${C.bdr}` }}
          >
            <button
              onClick={onCTA}
              className="font-heading italic cursor-pointer border-none bg-transparent transition-opacity hover:opacity-60"
              style={{
                fontSize: "clamp(16px, 1.8vw, 19px)",
                color: C.sage,
                lineHeight: 1.6,
                padding: 0,
              }}
              onMouseEnter={() => import("@/components/AuthModal")}
            >
              Ten mornings is enough to know if this is different. Begin free →
            </button>
            <p
              className="font-heading italic mt-3"
              style={{ fontSize: 13, color: C.txt3 }}
            >
              No credit card. No auto-charge.
            </p>
          </div>
        </FadeIn>

      </div>
    </section>
  );
}
